import PrintsSlider from './PrintsSlider';
import PrintsSliderContainer from './PrintsSlider.container';

export default PrintsSliderContainer(PrintsSlider);
